import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import lgVideo from 'lightgallery/plugins/video';
import { Subscription } from 'rxjs';
import { GalleryData, GalleryFile } from 'src/app/features/restaurants/models/Gallery';
import { GalleryService } from 'src/app/features/restaurants/services/Gallary.service';
import { StaffService } from 'src/app/features/staff/services/Staff.service';
import { UsersActions } from 'src/app/features/staff/UsersActions';
import { Record } from '../../models/List.GuestReviews';
import { ReviewService } from '../../services/Reviews.service';
import { ReportReviewFormComponent } from '../report-review-form/report-review-form.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-guest-review-details',
  templateUrl: './guest-review-details.component.html'
})
export class GuestReviewDetailsComponent implements OnInit {
  @Input() restaurantId!: any;
  @Input() selectedReviewId!: string;
  review!: Record;// reviewDetails;
  dataLoading = false;
  showHistory = false;
  @Output() close = new EventEmitter<boolean>();

  // image file
  avatar: any;
  avatarSrc!: string;
  maxFileSize = 0.8;
  fileTypeError = false;
  fileSizeError = false;

  Readmore = false;

  rate = 3

  settings = {
    counter: true,
    plugins: [lgVideo],
    selector: '.view-btn',
    // videojs: true,
    // videojsOptions: {
    //   muted: true,
    // },
    // source: [
    //   {
    //     src: '/videos/video1.mp4',
    //     type: 'video/mp4',
    //   }
    // ],
    // tracks: [
    //   {
    //     src: '/videos/title.txt',
    //     kind: 'captions'
    //   }
    // ],
    // attributes: { preload: false, controls: true },
  };

  galleryData!: GalleryData;
  subscriptions: Subscription[] = []
  selectedReservationId!: any;

  constructor(
    translate: TranslateService,
    public dialog: MatDialog,
    private service: ReviewService
  ) {
    // super(service, translate);
  }

  ngOnInit(): void {
    this.getDetails();
    this.subscriptions.push(
      this.service.refreshList.subscribe(data => {
        if (data) {
          this.getDetails();
        }
      })
    )
    this.subscriptions.push(
      this.service.closeDetails.subscribe(data => {
        if (data) {
          this.close.emit();
          this.service.closeDetails.next(false);
        }
      })
    )
  }
  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.service.closeDetails.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  openReportForm() {
    const dialogRef = this.dialog.open(ReportReviewFormComponent, {
      width: '50rem',
      data: { reviewId: this.selectedReviewId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.refreshList.next(true);
      }
    });
  }

  getDetails() {
    this.dataLoading = true;
    if (this.selectedReviewId) {
      this.service.GetDetails(this.selectedReviewId, this.restaurantId).subscribe(
        (data: any) => {
          this.dataLoading = false;
          if (data) {
            this.review = data as Record;
          }
        },
        (error: any) => {
          this.dataLoading = false;
        });
    }
  }

  videoType(item: GalleryFile) {
    return JSON.stringify({
      "source": [
        {
          "src": item.filePath,
          "type": item.type.toLowerCase() + '/' + item.extension
        }
      ],
      "attributes": {
        "preload": false,
        "playsinline": true,
        "controls": true
      }
    })
  }

}
